import React from 'react';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import { PortalNames } from "common/Portals";
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';

export const SidebarData = [
    {
        title: "Dashboard",
        icon: <DashboardOutlinedIcon />,
        link: `/${PortalNames.Contractor.Path}/dashboard`,
    },
    {
        title: "Contracts",
        icon: <WorkOutlineOutlinedIcon />,
        link: `/${PortalNames.Contractor.Path}/contracts`,
    },{
        title: "Uploads",
        icon: <PublishOutlinedIcon />,
        link: `/${PortalNames.Contractor.Path}/uploads`,
    }
]
